import { FormItem } from '@scts-ui/component-library';
import { Party } from '@scts/models';

export interface OnBehalfProps {
  onBehalf: Party;
}

const OnBehalf = (onBehalfProps: OnBehalfProps) => {
  return (
    <div className="text-primary ms-3">
      <FormItem
        header={''}
        detail={
          'On behalf of: ' +
          onBehalfProps.onBehalf.firstName +
          ' ' +
          onBehalfProps.onBehalf.lastName
        }
        minWidthHeader={'9.7rem'}
        minWidthDetail={'9.7rem'}
      />
    </div>
  );
};

export default OnBehalf;
